import './tick';
import './ticks';
import './ohlc';
import './ohlc_values';
import './readOhlc';
import './get_ohlc';
import './check_direction';
import './direction';
import './tick_analysis';
import './last_digit';
import './lastDigitList';



// WEBPACK FOOTER //
// ./src/botPage/view/blockly/blocks/ticks/index.js